// extracted by mini-css-extract-plugin
module.exports = {"uploadIcon":"EditProfileImageButton_uploadIcon_1N3ll"};